import debounce         from 'debounce';
import { MapDropwdown } from './MapDropwdown';

export default class EpisodeAccordion
{
	constructor ( $container )
	{
		this.$container       = $container;
		this.mobileSizeToggle = 767;
		this.currentMode      = window.innerWidth <= this.mobileSizeToggle ? "mobile" : "desktop";

		this.$togglers = Array.from( this.$container.querySelectorAll( '.season-select' ) );
		this.$sublists = Array.from( this.$container.querySelectorAll( '.episode-markers' ) );


		this.findHighestSeason();
		this.openPanel( this.highestSeason );
		this.bindEvents();

	}


	bindEvents ()
	{

		this.$togglers.forEach( toggler => toggler.addEventListener( 'click', this.handleTogglerClick.bind( this ) ) );

	}


	handleTogglerClick ( event )
	{
		const clicked       = event.target;
		const clickedSeason = parseInt( clicked.dataset.season );

		if ( clickedSeason === this.activeSeason )
		{
			this.closeAllPanels();
		} else
		{
			this.openPanel( clickedSeason );
		}
	}


	findHighestSeason ()
	{
		const seasons = this.$togglers.map( toggler => parseInt( toggler.dataset.season ) );
		seasons.sort();

		this.highestSeason = seasons.pop();

	}


	closeAllPanels ()
	{
		this.$togglers.forEach( toggler => toggler.classList.remove( 'open' ) );
		this.$sublists.forEach( sublist => sublist.classList.remove( 'open' ) );
		this.activeSeason = 0;
	}

	openPanel ( season )
	{
		this.$togglers.forEach( toggler =>
		{
			if ( parseInt( toggler.dataset.season ) === season )
			{
				toggler.classList.add( 'open' );
			} else
			{
				toggler.classList.remove( 'open' );
			}
		} );

		this.$sublists.forEach( sublist =>
		{
			if ( parseInt( sublist.dataset.season ) === season )
			{
				sublist.classList.add( 'open' );
			} else
			{
				sublist.classList.remove( 'open' );
			}
		} );


		this.activeSeason = season;
	}


}
const $allEpisodeLists = document.querySelectorAll( '.episode-marker-seasons' );

if ( $allEpisodeLists.length > 0 )
{

	$allEpisodeLists.forEach( ( el, i ) =>
	{
		const episodeAccordion = new EpisodeAccordion( el );
	} );
}
